import {
  type InsightsLandingPageItem,
  type InsightsLandingPageItemTargetClass,
} from "shared/modules/Insights/types";
import {
  Favorite,
  InstantInsightsReport,
  StreamReport,
} from "shared/resources";

export function isStreamReport(
  item: InsightsLandingPageItem
): item is StreamReport {
  return item instanceof StreamReport;
}

export function isInstantInsightsReport(
  item: InsightsLandingPageItem
): item is InstantInsightsReport {
  return item instanceof InstantInsightsReport;
}

export function isFavorite(item: InsightsLandingPageItem): item is Favorite {
  return item instanceof Favorite;
}

export function isLandingPageItemTarget(
  item: InsightsLandingPageItem
): item is InsightsLandingPageItemTargetClass {
  return isStreamReport(item) || isInstantInsightsReport(item);
}
